class HelperTraslatedCopy {
  /**
  * @Params
  * @Object {languageBundle}
  * @String {language}
  * @String {storefront}
  */
  constructor(languageBundle, language, storefront, country) {
    this.languageBundle = languageBundle;
    this.language = language;
    this.storefront = storefront;
    this.country = country;
    // Currency default MXN
    this.currency = 'MXN';
  }

  /**
  * @Params
  * @String {copyId} copyId CMS
  * @return @String {formatMessage}
  */
  getFormatMessageFromcopyId(copyId) {
    const defaultMessage = copyId;
    let formatMessage = '';
    if (this.languageBundle.hasOwnProperty(copyId)) {
      formatMessage = this.languageBundle[copyId];
    } else if ( defaultMessage ) {
      formatMessage = defaultMessage;
    }
    return formatMessage;
  }

  /**
  * @Params
  * @String {currencyCode}
  */
  setCurrency(currencyCode) {
    this.currency = currencyCode;
  }

  /**
  * @Params
  * @String {copyId} copyId CMS
  * @int {quantity} quantity for expression plural
  * @return @String {message}
  */
  formattedPluralMessage(copyId, quantity) {
    if (copyId === 'COMBO_ADMINFEE') {
      return this.formattedAdminFee(copyId);
    }
    const regex = /\{([^)]+)\}/g;
    const formatMessage = this.getFormatMessageFromcopyId(copyId);
    const strSingular = formatMessage.slice(1, -1).split(',')[2].split('other')[0];
    const strPlural = formatMessage.slice(1, -1).split(',')[2].split('other')[1];
    return quantity > 1 ? strPlural.match(regex)[0].slice(1, -1).replace('#', quantity) : strSingular.match(regex)[0].slice(1, -1).replace('#', quantity);
  }

  formattedAdminFee(copyId) {
    const formatMessage = this.getFormatMessageFromcopyId(copyId);
    return `${formatMessage}`;
  }

  /**
  * @Params
  * @String {number} number to format
  * @String {type} currency | decimal
  * @Bool {showCurrency} add currency
  * @Bool {showDecimals} add decimals
  * @return @String number formated
  */
  formattedNumber(number, type = 'currency', showCurrency = false, showDecimals = false) {
    let currency = '';
    const parameters = { style: type === 'puntos' ? 'decimal' : type };
    if (showCurrency) {
      currency = this.currency;
    }
    if (!showDecimals) {
      parameters['maximumFractionDigits'] = 0;
      parameters['minimumFractionDigits'] = 0;
    }
    if (type === 'currency') {
      parameters['currency'] = this.currency;
    }
    if (this.storefront === 'it-it') {
      this.storefront = 'en-IT';
    }
    let numberFormat = `${new Intl.NumberFormat(type === 'puntos' ? 'en-us' : this.storefront, parameters).format(number)}`.trim();
    numberFormat = numberFormat.replace(/USD\s/g, '$'); // storefront es-ni
    numberFormat = numberFormat.replace(/MXN\s/g, '$'); // storefront es-ni
    numberFormat = numberFormat.replace(/US/g, ''); // storefront es-do
    return `${numberFormat} ${currency}`;
  }
}

export default HelperTraslatedCopy;
